<template>
	<div class="shoppingCart">
		<div class="labelNav acea-row row-around row-middle">
			<div class="item">
				<span class="iconfont icon-xuanzhong"></span>100%正品保证
			</div>
			<div class="item">
				<span class="iconfont icon-xuanzhong"></span>所有商品精挑细选
			</div>
			<div class="item">
				<span class="iconfont icon-xuanzhong"></span>售后无忧
			</div>
		</div>
		<div class="nav acea-row row-between-wrapper">
			<div>
				商家数量 <span class="num font-color-red">{{ cartCount }}</span>
			</div>
			<!-- <div v-if="cartList.valid.length > 0" class="administrate acea-row row-center-wrapper" @click="manage">
				{{ footerswitch ? "取消" : "管理" }}
			</div> -->
		</div>
		<div v-if="cartList.valid !== undefined && cartList.valid.length > 0">
			<div class="list">
				<!-- 				<radio-group @change="checkboxChange2"> -->
				<div class="item acea-row row-between-wrapper" v-for="(item2, index2) in cartList.valid" :key="index2">
					<div class="item2 acea-row row-between-wrapper">
						<input type="radio" :value="index2.toString()" :checked="current == index2" style="width:20px;height:20px;border:1px solid #ccc;-webkit-appearance: radio;"
						 name="mendians" @change="checkboxChange2" />
						<!-- <radio :value="index2.toString()" :checked="current == index2"></radio> -->
						<div class="picTxt acea-row row-between-wrapper">
							<div class="pictrue" @click="gomendian(item2.merchant.id, item2.merchant.attr_tag)" hover-class="none">
								<img :src="item2.merchant.picture" alt="" />
							</div>
							<div class="text" @click="gomendian(item2.merchant.id, item2.merchant.attr_tag)" hover-class="none">
								<div class="line1">{{ item2.merchant.merchant_name }}</div>
								<div class="money">{{ item2.merchant.address }}</div>
							</div>
							<div class="carnum acea-row row-center-wrapper" @click="zhankai(index2)">
								<span class="iconfont icon-xiangxia" style="font-size:0.28rem"></span>
							</div>
						</div>
					</div>
					<!-- <checkbox-group @change="checkboxChange"> -->
					<div class="item2 acea-row row-between-wrapper" v-if="item2.show" v-for="(item, index) in item2.list" :key="index"
					 style="padding:5%">
						<input type="checkbox" style="width:20px;height:20px;border:1px solid #ccc;-webkit-appearance: checkbox;opacity:0" />
						<a :href="'/detail?id=' +
						  item.product_id +
						  '&mid=' +
						  item.merchant_id +
						  '&type=2'+
						  '&is_exchange='+item2.merchant.is_exchange
					  "
						 class="picTxt acea-row row-between-wrapper">
							<div class="pictrue">
								<img :src="item.productInfo.image" alt="" />
							</div>
							<div class="text">
								<div class="line1">{{ item.productInfo.store_name }}</div>
								<div class="infor line1" v-if="item.productInfo.attrInfo">
									属性：{{ item.productInfo.attrInfo.suk }}
								</div>
								<div class="money" v-if="item.vip_truePrice == 0">
									￥{{ item.truePrice }}
								</div>
								<div class="money" v-if="item.vip_truePrice != 0">
									￥{{ item.vip_truePrice }}
								</div>
							</div>
							<div class="carnum acea-row row-center-wrapper">
								<!-- <div :class="'reduce ' + (item.numSub ? 'on' : '')" @click.stop="subCart" :data-index="index">-</div> -->
								<div class="num">{{ item.cart_num }}</div>
								<!-- <div :class="'plus ' + (item.numAdd ? 'on' : '')" @click.stop="addCart" :data-index="index">+</div> -->
							</div>
						</a>
					</div>
					<!-- </checkbox-group> -->
				</div>
				<!-- </radio-group> -->
			</div>
		</div>
		<!--购物车暂无商品-->
		<!-- <div class="noCart" v-if="cartList.valid.length === 0 && cartList.invalid.length === 0">
			<div class="pictrue"><img src="@assets/images/noCart.png" /></div>
			<Recommend></Recommend>
		</div> -->
		<div style="height:2.1rem"></div>
		<div class="footer acea-row row-between-wrapper">
			<div style="opacity: 0;">
				<div class="select-btn">
					<div class="checkbox-wrapper">
						<label class="well-check">
							<input type="checkbox" name="" value="" />
							<i class="icon"></i>
							<span class="checkAll">全选</span>
						</label>
					</div>
				</div>
			</div>
			<div class="money acea-row row-middle" v-if="footerswitch == true">
				<span class="font-color-red">￥{{ selectCountPrice }}</span>
				<div class="placeOrder bg-color-red" @click="placeOrder()">
					立即下单
				</div>
			</div>
			<!-- <div class="button acea-row row-middle" v-else>
				<div class="bnt cart-color" @click="collectAll">收藏</div>
				<div class="bnt" @click="delgoods">删除</div>
			</div> -->
		</div>
	</div>
</template>
<script>
	import Recommend from "@components/Recommend";
	import {
		getCartList,
		getCartCounts,
		changeCartNum,
		cartDel,
		cartAll
	} from "@api/order";
	import {
		getProductHot,
		collectAll
	} from "@api/store";
	// import {getCartList,postCartDel,changeCartNum,getCartCount} from "@api/store";
	import {
		postCollectAll
	} from "@api/user";
	import {
		mul,
		add
	} from "@utils/bc";
	import cookie from "@utils/store/cookie";
	import debounce from "lodash.debounce";

	const CHECKED_IDS = "cart_checked";

	export default {
		name: "ShoppingCart",
		components: {
			Recommend
		},
		props: {},
		data: function() {
			const {
				mid = 0, cartype = 0
			} = this.$route.query;
			return {
				// cartList: {
				// 	invalid: [],
				// 	valid: []
				// },
				// isAllSelect: false,
				// cartCount: 0,
				countmoney: 0,
				// goodsHidden: true,
				// footerswitch: false,
				count: 0,
				checkedIds: [],
				loaded: false,
				navH: 0,
				cartCount: 0,
				goodsHidden: true,
				footerswitch: true,
				host_product: [],
				cartList: "",
				isAllSelect: false,
				//全选
				selectValue: [],
				//选中的数据
				selectCountPrice: 0.0,
				isGoIndex: true,
				iShidden: false,
				validData: "",
				itemData: "",
				indexList: 0,
				current: -1
			};
		},
		watch: {
			// $route(n) {
			// 	this.merchant_id = n.query.mid;
			// 	this.cartype = n.query.cartype;
			// 	if (n.name === "ShoppingCart") {
			// 		this.carnum();
			// 		this.countMoney();
			// 		this.getCartList();
			// 		this.gainCount();
			// 		this.goodsHidden = true;
			// 		this.footerswitch = false;
			// 	}
			// }
		},
		mounted: function() {
			this.getHostProduct();
			this.getCartList();
			this.getCartNum();
		},
		methods: {
			placeOrder: function() {
				let that = this;
				// list = that.cartList.valid,
				// id = [];
				// list.forEach(function(val) {
				//   if (val.checked === true) {
				//     id.push(val.id);
				//   }
				// });
				// if (id.length === 0) {
				//   that.$dialog.toast({ mes: "请选择产品" });
				//   return;
				// }
				// console.log(selectValue)
				var selectValue = this.selectValue;
				for (
					var i = 0; i < this.cartList.valid[this.indexList].list.length; i++
				) {
					selectValue.push(this.cartList.valid[this.indexList].list[i].id);
				}
				// selectValue.join(',')
				this.$router.push({
					path: "/order/submit/" + selectValue.join(",")+"?is_exchange="+this.cartList.valid[this.current].merchant.is_exchange
				});
			},
			gomendian(id, tag) {
				let that = this;
				if (id) {
					that.$router.push({
						path: "/mendian/mendian/" + id + "?tag=" + tag
					});
				} else {
					that.$router.push({
						path: "/vipshangc/vipStore"
					});
				}
			},
			checkboxChange2(evt) {
				this.selectCountPrice = 0;
				this.current = evt.target.value;
				this.indexList = evt.target.value;
				for (
					var i = 0; i < this.cartList.valid[this.indexList].list.length; i++
				) {
					if (this.cartList.valid[this.indexList].list[i].vip_truePrice == 0) {
						this.selectCountPrice +=
							this.cartList.valid[this.indexList].list[i].cart_num *
							this.cartList.valid[this.indexList].list[i].truePrice;
					} else {
						this.selectCountPrice +=
							this.cartList.valid[this.indexList].list[i].cart_num *
							this.cartList.valid[this.indexList].list[i].vip_truePrice;
					}
				}
				// console.log(this.cartList.valid[this.indexList].show = !this.cartList.valid[this.indexList].show)
				var that = this;
				that.selectValue = [];
				var selectValue = that.selectValue;
				for (
					var i = 0; i < this.cartList.valid[this.indexList].list.length; i++
				) {
					selectValue.push(this.cartList.valid[this.indexList].list[i].id);
				}
			},
			zhankai(index) {
				var that = this;
				console.log(index, this.indexList);
				if (index == this.indexList) {
					// console.log(this.cartList.valid[index])
					this.cartList.valid[index].show = !this.cartList.valid[index].show;
				} else {
					that.$dialog.toast({
						mes: "请先选择商户"
					});
				}
			},
			/**
			 * 关闭授权
			 *
			 */
			onCloseAuto: function() {
				this.setData({
					iShidden: true
				});
			},
			subDel: function(event) {
				// var formId = event.detail.formId,
				// that = this,
				var selectValue = that.selectValue;
				// setFormId(formId);
				if (selectValue.length > 0)
					cartDel(selectValue).then(res => {
						this.getCartList();
						this.getCartNum();
					});
				else
					return getApp().globalData.Tips({
						title: "请选择产品"
					});
			},
			getSelectValueProductId: function() {
				var that = this;
				var validList = that.cartList.valid;
				var selectValue = that.selectValue;
				var productId = [];

				if (selectValue.length > 0) {
					for (var index in validList) {
						if (that.inArray(validList[index].id, selectValue)) {
							productId.push(validList[index].product_id);
						}
					}
				}

				return productId;
			},
			subCollect: function(event) {
				var formId = event.detail.formId,
					that = this,
					selectValue = that.selectValue;
				setFormId(formId);

				if (selectValue.length > 0) {
					var selectValueProductId = that.getSelectValueProductId();
					collectAll(that.getSelectValueProductId().join(","))
						.then(res => {
							return getApp().globalData.Tips({
								title: res.msg,
								icon: "success"
							});
						})
						.catch(err => {
							return getApp().globalData.Tips({
								title: err
							});
						});
				} else {
					return getApp().globalData.Tips({
						title: "请选择产品"
					});
				}
			},
			subOrder: function(event) {
				console.log(event);
				console.log(this);
				// var formId = event.detail.formId,
				// var selectValue = this.cartList.valid[this.indexList].list.
				console.log(selectValue);
				var selectValue = this.selectValue;
				for (
					var i = 0; i < this.cartList.valid[this.indexList].list.length; i++
				) {
					selectValue.push(this.cartList.valid[this.indexList].list[i].id);
				}
				// setFormId(formId);

				// if (selectValue.length > 0) {
				// uni.navigateTo({
				// 	url: '/pages/order_confirm/index?cartId=' + selectValue.join(',')
				// });
				// } else {
				// 	return getApp().globalData.Tips({
				// 		title: '请选择产品'
				// 	});
				// }
			},
			checkboxAllChange: function(event) {
				var value = event.detail.value;

				if (value.length > 0) {
					this.setAllSelectValue(1);
				} else {
					this.setAllSelectValue(0);
				}
			},
			setAllSelectValue: function(status) {
				var that = this;
				var selectValue = [];
				var valid = that.cartList.valid;

				if (valid.length > 0) {
					for (var index in valid) {
						if (status == 1) {
							valid[index].checked = true;
							selectValue.push(valid[index].id);
						} else valid[index].checked = false;
					}

					var validData = "cartList.valid";
					that.setData({
						[validData]: valid,
						selectValue: selectValue
					});
					that.switchSelect();
				}
			},
			checkboxChange: function(event) {
				var that = this;
				console.log(that.selectCountPrice);
				console.log(event);
				var value = event.detail.value;
				console.log(value);
				var valid = that.cartList.valid[that.indexList];
				console.log(that.cartList.valid[that.indexList].list);
				if (value.length == 0) {
					that.selectCountPrice = 0.0;
				} else {
					// this.selectCountPrice =
					for (var i = 0; i < value.length; i++) {
						for (
							var j = 0; j < that.cartList.valid[that.indexList].list.length; j++
						) {
							if (that.cartList.valid[that.indexList].list[j].id == value[i]) {
								if (
									that.cartList.valid[that.indexList].list[j].vip_truePrice == 0
								) {
									that.selectCountPrice +=
										that.cartList.valid[that.indexList].list[j].cart_num *
										that.cartList.valid[that.indexList].list[j].truePrice;
								} else {
									that.selectCountPrice +=
										that.cartList.valid[that.indexList].list[j].cart_num *
										that.cartList.valid[that.indexList].list[j].vip_truePrice;
								}
							}
						}
					}
					console.log(this.selectCountPrice);
				}
				// for (var index in valid) {
				// 	if (that.inArray(valid[index].id, value)) valid[index].checked = true;
				// 	else valid[index].checked = false;
				// }

				// var validData = 'cartList.valid';
				// this.setData({
				// 	[validData]: valid,
				// 	isAllSelect: value.length == this.cartList.valid.length,
				// 	selectValue: value
				// });
				this.switchSelect();
			},
			inArray: function(search, array) {
				for (var i in array) {
					if (array[i] == search) {
						return true;
					}
				}

				return false;
			},
			switchSelect: function() {
				var that = this;
				var validList = that.cartList.valid;
				var selectValue = that.selectValue;
				var selectCountPrice = 0.0;

				if (selectValue.length < 1) {
					that.setData({
						selectCountPrice: selectCountPrice
					});
				} else {
					for (var index in validList) {
						if (that.inArray(validList[index].id, selectValue)) {
							selectCountPrice =
								Number(selectCountPrice) +
								Number(validList[index].cart_num) *
								Number(validList[index].truePrice);
						}
					}

					that.setData({
						selectCountPrice: selectCountPrice.toFixed(2)
					});
				}
			},
			subCart: function(event) {
				var that = this;
				var status = false;
				var index = event.currentTarget.dataset.index;
				// var item = that.cartList.valid[index];
				var item = that.cartList.valid[that.indexList].list[index];
				console.log(item);
				item.cart_num = item.cart_num - 1;
				if (item.cart_num < 1) status = true;

				if (item.cart_num <= 1) {
					item.cart_num = 1;
					item.numSub = true;
				} else {
					item.numSub = false;
					item.numAdd = false;
				}

				if (false == status) {
					that.setCartNum(item.id, item.cart_num, function(data) {
						var itemData = "cartList.valid[" + index + "]";
						that.setData({
							[itemData]: item
						});
						that.switchSelect();
					});
				}
			},
			addCart: function(event) {
				var that = this;
				var index = event.currentTarget.dataset.index;
				console.log(index);
				var item = that.cartList.valid[that.indexList].list[index];
				console.log(that.cartList);
				console.log(item);
				item.cart_num = item.cart_num + 1;
				var productInfo = item.productInfo;
				console.log(item);
				if (
					productInfo.hasOwnProperty("attrInfo") &&
					item.cart_num >= item.productInfo.attrInfo.stock
				) {
					item.cart_num = item.productInfo.attrInfo.stock;
					item.numAdd = true;
					item.numSub = false;
				} else if (item.cart_num >= item.productInfo.stock) {
					item.cart_num = item.productInfo.stock;
					item.numAdd = true;
					item.numSub = false;
				} else {
					item.numAdd = false;
					item.numSub = false;
				}

				that.setCartNum(item.id, item.cart_num, function(data) {
					var itemData = "cartList.valid[" + index + "]";
					that.setData({
						[itemData]: item
					});
					that.switchSelect();
				});
			},

			setCartNum(cartId, cartNum, successCallback) {
				var that = this;
				changeCartNum(cartId, cartNum).then(res => {
					successCallback && successCallback(res.data);
				});
			},

			getCartNum: function() {
				var that = this;
				getCartCounts().then(res => {
					// that.setData({
					// 	cartCount: res.data.count
					// });
				});
			},
			getCartList: function() {
				var that = this;
				cartAll().then(res => {
					// console.log(res)
					that.cartList = res.data;
					that.cartCount = res.data.valid.length;
					var valid = that.cartList.valid[that.indexList].list;
					console.log(that.indexList);
					console.log(that.cartList);
					var numSub = [{
							numSub: true
						},
						{
							numSub: false
						}
					];
					var numAdd = [{
							numAdd: true
						},
						{
							numAdd: false
						}
					];
					console.log(valid);
					if (valid.length > 0) {
						for (var index in valid) {
							if (valid[index].cart_num == 1) {
								valid[index].numSub = true;
							} else {
								valid[index].numSub = false;
							}

							var productInfo = valid[index].productInfo;

							if (valid[index].cart_num == valid[index].productInfo.stock) {
								valid[index].numAdd = true;
							} else {
								valid[index].numAdd = false;
							}

							valid[index].checked = false;
						}
					}
					// that.setData({
					//   cartList: cartList,
					//   goodsHidden: cartList.valid.length <= 0 ? false : true
					// });
					for (var i = 0; i < that.cartList.valid[0].list.length; i++) {
						if (that.cartList.valid[0].list[i].vip_truePrice == 0) {
							that.selectCountPrice +=
								that.cartList.valid[0].list[i].cart_num *
								that.cartList.valid[0].list[i].truePrice;
						} else {
							that.selectCountPrice +=
								that.cartList.valid[0].list[i].cart_num *
								that.cartList.valid[0].list[i].vip_truePrice;
						}
					}
					console.log(that.selectCountPrice);
					that.switchSelect();
				});
			},
			getHostProduct: function() {
				var that = this;
				getProductHot().then(res => {
					that.setData({
						host_product: res.data
					});
				});
			},
			goodsOpen: function() {
				var that = this;
				that.setData({
					goodsHidden: !that.goodsHidden
				});
			},
			manage: function() {
				var that = this;
				that.setData({
					footerswitch: !that.footerswitch
				});
			},
			onLoadFun: function() {
				this.getHostProduct();
				this.getCartList();
				this.getCartNum();
				this.iShidden = true;
			},
			setData: function(obj) {
				let that = this;
				let keys = [];
				let val, data;
				Object.keys(obj).forEach(function(key) {
					keys = key.split(".");
					val = obj[key];
					data = that.$data;
					keys.forEach(function(key2, index) {
						if (index + 1 == keys.length) {
							that.$set(data, key2, val);
						} else {
							if (!data[key2]) {
								that.$set(data, key2, {});
							}
						}

						data = data[key2];
					});
				});
			}
		}
	};
</script>
